export const html = "<p>Eat the Gyumri specialty, qyalla.</p>\n";
export const leadHtml = "<p>Eat the Gyumri specialty, qyalla.</p>\n";
export const bodyHtml = "";
export const metaText = "Eat the Gyumri specialty, qyalla.";